import React, { useState } from 'react'
import { Dropdown, Tabs, Menu } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'
import { BiSelectMultiple } from 'react-icons/bi'

import { normalize, stringifyDate, usePet, useToggle } from '../../modules'

import Modal from "../resusable/modal"
import Receive from '../resusable/receive'
import EditItem from './editItem'

const { TabPane } = Tabs

const Invoice = ({ toggle, visible, invoice: inv, onPerform }) => {
    const [chosen, setChosen] = useState([])
    const [selected, setSelected] = useState(null)
    const [index, setIndex] = useState(null)
    const [can, setCan] = useState(null)

    const [select, toggleSelect] = useToggle()
    const [editModal, toggleEditModal] = useToggle()

    const [{ loading, error, data: invoice }, refetch] = usePet('invoice', { id: inv?._id }, { notify: true })

    const togSelect = () => {
        setChosen([])
        toggleSelect()
    }

    const selectItems = (val, i) => {
        setSelected(val)
        setIndex(i)
        toggleEditModal()
    }

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const [{ loading: eLoading }, edit] = usePet('editInvoiceItem', {
        parent: inv?._id,
        index,
        ...can
    }, { notify: true, callback: (_, notif, ops) => {
        notif('Changes have been saved', ops('success'))
        refetch()
    }, manual: true, load: { msg: 'Saving...' } })

    const [{ loading: sLoading }, deleteFromInvoice] = usePet('deleteItemsFromInvoice', {
        parent: inv?._id,
        ids: chosen
    }, { notify: true, callback: (_, notif, ops) => {
        notif('Items have been deleted', ops('success'))
        onPerform()
        togSelect()
        setTimeout(toggle, 300)
    }, manual: true, load: { msg: 'Deleting...' } })

    const [{ loading: cLoading }, commitInvoice] = usePet('commitInvoice', {
        id: inv?._id
    }, { notify: true, callback: (_, notif, ops) => {
        notif('Invoice has been committed', ops('success'))
        onPerform()
        refetch()
        setTimeout(toggle, 300)
    }, manual: true, load: { msg: 'Committing...' } })

    const [{ loading: dLoading }, deleteInvoice] = usePet('deleteInvoice', {
        id: inv?._id
    }, { notify: true, callback: (_, notif, ops) => {
        notif('Invoice has been deleted', ops('success'))
        onPerform()
        setTimeout(toggle, 300)
    }, manual: true, load: { msg: 'Deleting...' } })

    return (
        <Modal
            h="h-auto my-5"
            // w="w-5/6 md:w-4/5 xl:w-3/5 2xl:w-2/5 mt-5"
            align="items-start"
            title={`Invoice #${invoice?.code}`}
            toggle={toggle}
            visible={visible}>
            {
                editModal &&
                <EditItem
                    onPerform={ nw => {
                        setCan(nw)
                        edit()
                    } }
                    record={ selected }
                    toggle={ toggleEditModal }
                    visible={ editModal } />
            }
            <Receive
                loading={loading}
                error={error}>
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Items" key="1">
                        <span className="flex justify-end">
                            {
                                !inv?.committed ?
                                    chosen.length > 0 ?
                                        <Dropdown
                                            overlay={
                                                <Menu>
                                                    <Menu.Item onClick={togSelect}>Deselect All</Menu.Item>
                                                    {
                                                        !invoice?.committed ?
                                                        <Menu.Item onClick={deleteFromInvoice}>Delete</Menu.Item>
                                                            : null
                                                    }
                                                </Menu>
                                            }>
                                            <button className="btn mb-3 hisani-btn-green text-white">
                                                <span className="hidden xs:block mr-2">Actions ({chosen.length})</span>
                                                <AiOutlineDown />
                                            </button>
                                        </Dropdown>
                                        :
                                        <Dropdown
                                            overlay={
                                                <Menu>
                                                    <Menu.Item onClick={togSelect}>{!select ? "Select" : "Deselect All"}</Menu.Item>
                                                    <Menu.Item onClick={commitInvoice}>Commit Invoice</Menu.Item>
                                                    <Menu.Item onClick={deleteInvoice}>Delete Invoice</Menu.Item>
                                                </Menu>
                                            }>
                                            <button className="btn mb-3 hisani-btn-green text-white">
                                                <span className="hidden xs:block mr-2">Actions</span>
                                                <AiOutlineDown />
                                            </button>
                                        </Dropdown>
                                    : null
                            }
                        </span>
                        <table className="table-auto w-full">
                            {/* Table header */}
                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                <tr>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">No</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Item</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Quantity</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Price</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Disc</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Tax</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Total</div>
                                    </th>
                                    {
                                        !invoice?.committed &&
                                        <th className="p-2"/>
                                    }
                                </tr>
                            </thead>
                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                {
                                    invoice?.items?.map((item, key) =>
                                        <tr>
                                            <td className="p-2">
                                                <div className="text-center">
                                                    {
                                                        select ?
                                                            <input
                                                                onChange={() => choose(item._id)}
                                                                checked={chosen.includes(item._id)}
                                                                type="checkbox"
                                                                className="form-checkbox cursor-pointer h-5 w-5" />
                                                            : `${key + 1}.`
                                                    }
                                                </div>
                                            </td>
                                            <td className="p-2">
                                                <div className="text-left">{item.item.name}</div>
                                            </td>
                                            <td className="p-2 text-left">
                                                <div className="text-left">{ Math.abs(item.bulkCount) } X { Math.abs(item.containing) } ({ Math.abs(item.bulkCount * item.containing) })</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="text-left">Ksh. { item.bp || item.price }</div>
                                            </td>
                                            <td className="p-2 text-left">
                                                <div className="text-left">Ksh. { normalize(item?.discount) }</div>
                                            </td>
                                            <td className="p-2 text-left">
                                                <div className="text-left">{item?.vat}%</div>
                                            </td>
                                            <td className="p-2 text-left">
                                                <div className="text-left">Ksh. { normalize(Math.abs(item.bulkCount * item.containing) * ((item.bp || item.price) - item.discount)) }</div>
                                            </td>
                                            {
                                                !invoice?.committed &&
                                                <td className="p-2">
                                                    <button onClick={ () => selectItems(item, key) } className="btn hisani-btn-green text-white">
                                                        <span className="hidden xs:block mr-2">Edit</span>
                                                    </button>
                                                </td>
                                            }
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        <div className="flex flex-col items-end pr-3 py-3">
                            <p className="font-semibold text-lg underline mb-2">Overview</p>
                            <p className="mb-1">Discount: Ksh. { normalize(invoice?.items?.reduce((total, item) => total + ((item.bulkCount * item.containing) * item.discount), 0)) }</p>
                            <p className="mb-1">Before Tax: Ksh. { normalize(invoice?.items?.reduce((total, item) => total + (Math.abs(item.bulkCount * item.containing) * ((item.bp || item.price) - item.discount) * (item.vat / 100)), 0)) }</p>
                            <p className="mb-1">Tax (16%): Ksh. { normalize(invoice?.items?.reduce((total, item) => total + (Math.abs(item.bulkCount * item.containing) * ((item.bp || item.price) - item.discount) * ((100 - item.vat) / 100)), 0)) }</p>
                            <p className="mb-1">Total: Ksh. { normalize(invoice?.items?.reduce((total, item) => total + (Math.abs(item.bulkCount * item.containing) * ((item.bp || item.price) - item.discount)), 0)) }</p>
                        </div>
                    </TabPane>
                    <TabPane tab="Additional Info" key="3">
                    </TabPane>
                </Tabs>
            </Receive>
        </Modal>
    )
}

export default Invoice